import {SnackbarType} from '@treez-ui/core/feedback/modals';
import {ProductValidationResult} from '@treez/commons/jsonSchema/products/product';
import {ProductRegion} from '@treez/commons/jsonSchema/products/regionSchemas';
import {Product, ProductData} from '@treez/commons/sharedTypings/product';
import {Dispatch} from 'react';
import {clearSnackbar, showSnackbar} from '~/redux/actions/SnackbarActions';
import {StoreAttributes} from './directory';
import {getStoreRegion} from './entity';
import {validateProductWrapper} from './product';

export type ProductValidationErrorReport = Record<ProductData, string>;

export type HandleProductValidationFunction = (
    field: ProductData,
    errorPresent: boolean,
    errorMessage?: string
) => void;

export interface StoreProductValidationResult {
    productValidationResult: ProductValidationResult;
    store?: StoreAttributes;
    region?: string;
}

export const getStoreByCatalogId = (
    catalogId: number,
    stores: StoreAttributes[] | undefined
): StoreAttributes | undefined => {
    const store = (stores || []).find((item) => item.catalogId === catalogId);
    return store;
};

export const getStoreProductValidationResult = (
    product: Partial<Product>,
    catalogIds: number[],
    stores: StoreAttributes[] | undefined,
    dispatch: Dispatch<any>
) => {
    const storeProductValidationErrorResult: StoreProductValidationResult[] = [];
    catalogIds.forEach((catalogId) => {
        const store = getStoreByCatalogId(catalogId, stores);

        if (store !== null) {
            const region = getStoreRegion(store);

            const validationResult: ProductValidationResult = validateProductWrapper(
                product,
                ProductRegion[region!]
            );

            if (validationResult.isValid === false) {
                storeProductValidationErrorResult.push({
                    productValidationResult: validationResult,
                    region,
                    store,
                });
            }
        } else {
            dispatch(
                showSnackbar({
                    onClose: () => dispatch(clearSnackbar()),
                    type: SnackbarType.WARNING,
                    content: `There isn't a store associated with catalog id ${catalogId}, please contact support@treez.io`,
                })
            );
        }
    });

    return storeProductValidationErrorResult;
};
